angular.module('natgeo').factory('TextBubble', ['DropShadow', 
function TextBubble(DropShadow)
{
	// hhttp://jsfiddle.net/02897vos/2/

	var NAMESPACE = "http://www.w3.org/2000/svg";

	function createSVG(topWidth, bottomWidth, height, borderRadius, borderWidth, borderColor, backgroundColor, dropshadow, rotate, fullWidth, fullHeight) 
	{
		var widthDiff = topWidth - bottomWidth;
		var shift = borderRadius * widthDiff / height;
		var el = document.createElementNS( NAMESPACE, "path" );
		var def = '';
		// Move
		def += 'M ' + (borderWidth / 2) + ' ' + (borderWidth / 2 + borderRadius);
		// Top Left Corner
		def += ' q 0 ' + (-borderRadius) + ' ' + (borderRadius) + ' ' + (-borderRadius);
		// Top Line
		def += ' l ' + (topWidth - borderRadius * 2) + ' 0';
		// Top Right Corner
		def += ' q ' + (borderRadius + shift) + ' 0 ' + (borderRadius) + ' ' + (borderRadius + shift * 0.5);
		// Right Line
		def += ' l ' + (-widthDiff) + ' ' + (height - borderRadius * 2);
		// Bottom Right Corner
		def += ' q ' + (-shift) + ' ' + (borderRadius) + ' ' + (-borderRadius) + ' ' + (borderRadius);
		// Bottom Line
		def += ' l ' + (-bottomWidth + borderRadius * 2) + ' 0';
		// Bottom Left Corner
		def += ' q ' + (-borderRadius) + ' 0 ' + (-borderRadius) + ' ' + (-borderRadius);
		// End
		def += ' z';

		// Properties
		el.setAttribute('d', def);
		el.setAttribute('stroke', borderColor);
		el.setAttribute('stroke-width', borderWidth);
		el.setAttribute('fill', backgroundColor);

		if (dropshadow)
		{
			DropShadow( el );
		}

		if (rotate)
		{
			var cx = (fullWidth * 0.5);
			var cy = (fullHeight * 0.5);

			el.setAttribute('transform', 'translate(' + cx + ' ' + cy + ') rotate(' + rotate + ') translate(-' + cx + ' -' + cy + ')');
		}

		return el;
	}

	return function(element, container)
	{
		// Scale element, making sure any data-rect has been expanded and removed.
		element.scale( container.getScale() );

		// Determine text bubble parameters from element data attributes.
		var scale           = parseFloat( element.data('scale') ) || 1.0;
		var topWidth 			  = parseFloat( element.data('topWidth') || element.data('width') );
		var bottomWidth 	  = parseFloat( element.data('bottomWidth') || (topWidth * 0.90) );
		var height 				  = parseFloat( element.data('height') );
		var borderRadius 	  = parseFloat( element.data('borderRadius') ) || 40;
		var borderWidth     = parseFloat( element.data('borderWidth') ) || 15;
		var borderColor     = element.data('borderColor') || '#C0D609';
		var backgroundColor = element.data('backgroundColor') || '#FFFFFF';
		var rotate          = element.data('rotate');
		var dropshadow      = element.data('dropshadow') !== 'false';

		// Generate the SVG path element
		function generatePath()
		{
			var containerScale = container.getScale();
			var dimensionScale = scale * containerScale;
			var padding = borderWidth * containerScale * 2;

			if (dropshadow)
			{
				padding += borderWidth * containerScale;
			}

			return $(createSVG(
				topWidth 			* dimensionScale - padding,
				bottomWidth 	* dimensionScale - padding,
				height 				* dimensionScale - padding,
				borderRadius 	* containerScale,
				borderWidth 	* containerScale,
				borderColor,
				backgroundColor,
				dropshadow,
				rotate,
				topWidth      * dimensionScale,
				height        * dimensionScale
			));
		};

		// When the SVG element is scaled, recreate the path.
		element.on('scaled', function()
		{
			element.empty();
			element.append( generatePath() );
		});

		// Invoked scaled to add the path the SVG element
		element.trigger( 'scaled' );
	};
}]);